import React, { useState, useEffect } from "react";
import Close from "../../../../Icons/Close";
import { styles } from "../../../../ReactConst";
import { StyleRoot } from "radium";
export default function ModalErreurDeleteCompte(props) {
  const [styleFadeIn, setFadeIn] = useState(true);
  const CloseModalErreurDeleteCompte = React.useCallback(() => {
    setFadeIn(false);
    setTimeout(() => {
      props.closeModaErreurDeleteCompte();
    }, 400);
  }, []);

  return (
    <StyleRoot>
      <div
        className="modal show modal-skin"
        style={styleFadeIn === true ? styles.bounce : styles.bounce2}
        id="modalConfirm"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <form
              onSubmit={(e) => {
                e.preventDefault();
                CloseModalErreurDeleteCompte();
              }}
            >
              <button
                onClick={CloseModalErreurDeleteCompte}
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <Close src="img/close.svg" className="img-fluid" alt="" />
              </button>
              <div className="modal-body">
                <section>
                  <h5 className="modal-title">Supprimer votre compte</h5>
                </section>
                <section>
                  <h5>
                    Vous êtes le seul administrateur du compte de votre crèche.
                    Le compte de la crèche doit avoir au moins un
                    administrateur.
                  </h5>
                </section>
                <p className="bottom-space"></p>
                <section>
                  <div className="d-flex justify-content-center">
                    <button type="submit" className="btn-gradient btn-confirm">
                      <img
                        src="img/icon-check-white.svg"
                        className="img-fluid"
                        alt=""
                      />{" "}
                      Ok
                    </button>
                  </div>
                </section>
              </div>
            </form>
          </div>
        </div>
      </div>
    </StyleRoot>
  );
}
